[
    {
        "en": "future-of-digital-certificates-by-pok",
        "es": "futuro-certificados-digitales-por-pok",
        "pt": "futuro-certificados-digitais-pok"
    },
    {
        "en": "pok-education-employability-ai-learning-analytics-and-blockchain-digital-credentials",
        "es": "educacion-empleabilidad-analitica-aprendizaje-ia-credenciales-digitales-blockchain-pok",
        "pt": "pok-educacao-empregabilidade-ia-analytics-aprendizado-blockchain-credenciais-digitais"
    },
    {
        "en": "digital-credential-acceptance-rate-graduates-how-to-raise-it",
        "es": "tasa-aceptacion-credenciales-digitales-egresados-como-aumentarla",
        "pt": "taxa-aceite-credenciais-digitais-egressos-como-aumentar"
    },
    {
        "en": "add-credential-to-linkedin-profile-keywords-unicesumar",
        "es": "como-agregar-credencial-linkedin-palabras-clave-unicesumar",
        "pt": "como-adicionar-credencial-linkedin-palavras-chave-unicesumar"
    },
    {
        "en": "digital-certificates-conferences-events-universidad-senor-de-sipan",
        "es": "certificados-digitales-congresos-eventos-universidad-senor-de-sipan",
        "pt": "certificados-digitais-congressos-eventos-universidad-senor-de-sipan"
    },
    {
        "en": "issue-digital-credentials-from-your-platform-flexflix",
        "es": "emitir-credenciales-digitales-desde-tu-plataforma-flexflix",
        "pt": "emitir-credenciais-digitais-da-sua-plataforma-flexflix"
    },
    {
        "en": "moodle-certificates-verifiable-digital-credentials",
        "es": "certificados-verificables-moodle-credenciales-digitales",
        "pt": "certificados-verificaveis-moodle-credenciais-digitais"
    },
    {
        "en": "certifying-ai-skills-microcredentials-universidad-ean",
        "es": "certificar-competencias-ia-microcredenciales-universidad-ean",
        "pt": "certificar-competencias-ia-microcredenciais-universidad-ean"
    },
    {
        "en": "blockchain-credential-verification-cost-blockchain-verify",
        "es": "verificacion-credenciales-blockchain-costo-blockchain-verify",
        "pt": "verificacao-credenciais-blockchain-custo-blockchain-verify"
    },
    {
        "en": "universidad-de-guadalajara-verifiable-digital-certificates-pok",
        "es": "universidad-de-guadalajara-constancias-digitales-verificables-pok",
        "pt": "universidade-de-guadalajara-certificados-digitais-verificaveis-pok"
    },
    {
        "en": "microcredentials-blockchain-learning-employability",
        "es": "microcredenciales-blockchain-aprendizaje-empleabilidad",
        "pt": "microcredenciais-blockchain-aprendizado-empregabilidade"
    },
    {
        "en": "pok-digital-credential-issuance-smart-integrations",
        "es": "pok-integraciones-certificados-digitales",
        "pt": "pok-integracoes-credenciais-digitais"
    },
    {
        "en": "pok-iee-equivalency-global-academic-recognition",
        "es": "pok-iee-equivalency-reconocimiento-academico-global",
        "pt": "pok-iee-equivalency-reconhecimento-academico-global"
    },
    {
        "en": "pok-sovra-strategic-alliance-digital-trust-infrastructure",
        "es": "pok-sovra-alianza-estrategica-infraestructura-confianza-digital",
        "pt": "pok-sovra-alianca-estrategica-infraestrutura-confianca-digital"
    },
    {
        "en": "pok-official-nft-digital-certificate-platform-at-asu-gsv-summit-2025-in-san-diego",
        "es": "pok-official-nft-digital-certificate-platform-at-asu-gsv-summit-2025-in-san-diego",
        "pt": "pok-oficial-plataforma-de-certificados-digitais-nft-no-asu-gsv-summit-2025-em-san-diego"
    },
    {
        "en": "stackable-microcredentials-academic-credit-universidad-santo-tomas",
        "es": "microcredenciales-homologables-universidad-santo-tomas-santotoup",
        "pt": "microcredenciais-empilhaveis-creditos-universidad-santo-tomas"
    },
    {
        "en": "ai-written-resume-verifiable-credentials-hiring-trust",
        "es": "curriculum-ia-credenciales-verificables-contratacion",
        "pt": "curriculo-ia-credenciais-verificaveis-contratacao"
    },
    {
        "en": "how-employers-verify-digital-credentials",
        "es": "como-verifican-empleadores-credenciales-digitales",
        "pt": "como-empregadores-verificam-credenciais-digitais"
    },
    {
        "en": "value-of-digital-credentials-commodity-trust-infrastructure",
        "es": "valor-credenciales-digitales-infraestructura-confianza",
        "pt": "valor-credenciais-digitais-infraestrutura-confianca"
    },
    {
        "en": "credly-alternatives",
        "es": "alternativas-a-credly",
        "pt": "alternativas-ao-credly"
    },
    {
        "en": "accredible-alternatives",
        "es": "alternativas-a-accredible",
        "pt": "alternativas-ao-accredible"
    },
    {
        "en": "best-digital-credential-platforms-2026",
        "es": "mejores-plataformas-credenciales-digitales-2026",
        "pt": "melhores-plataformas-credenciais-digitais-2026"
    },
    {
        "en": "open-badge-3-0-complete-guide-digital-credentials",
        "es": "open-badge-3-0-guia-completa-credenciales-digitales",
        "pt": "open-badge-3-0-guia-completo-credenciais-digitais"
    },
    {
        "en": "credly-vs-pok-pricing-2026",
        "es": "credly-vs-pok-precios-2026",
        "pt": "credly-vs-pok-precos-2026"
    },
    {
        "en": "digital-credentials-educational-institutions-choosing-platform",
        "es": "credenciales-digitales-instituciones-educativas-elegir-plataforma",
        "pt": "credenciais-digitais-instituicoes-educacionais-escolher-plataforma"
    },
    {
        "en": "boost-sales-blockchain-digital-credentials-pok",
        "es": "impulsa-ventas-credenciales-digitales-blockchain-pok",
        "pt": "impulsione-vendas-credenciais-digitais-blockchain-pok"
    },
    {
        "en": "credential-revocation-pok-digital-trust",
        "es": "revocacion-credenciales-digitales-pok",
        "pt": "revogacao-credenciais-digitais-pok"
    },
    {
        "en": "microcredentials-future-verifiable-learning",
        "es": "microcredenciales-futuro-aprendizaje-verificable",
        "pt": "microcredenciais-futuro-aprendizagem-verificavel"
    },
    {
        "en": "privacy-data-protection-digital-credentials-pok",
        "es": "privacidad-proteccion-datos-credenciales-digitales-pok",
        "pt": "privacy-data-protection-digital-credentials-pok"
    },
    {
        "en": "selective-presentation-user-control-digital-credentials",
        "es": "presentacion-selectiva-control-usuario-credenciales-digitales",
        "pt": "apresentacao-seletiva-controle-usuario-credenciais-digitais"
    },
    {
        "en": "boost-career-digital-credentials-visibility-growth",
        "es": "impulsa-carrera-credenciales-digitales-crecimiento",
        "pt": "impulsione-carreira-credenciais-digitais-visibilidade-crescimento"
    },
    {
        "en": "digital-credentials-microcredentials-gamification-career-pok",
        "es": "credenciales-microcredenciales-digitales-gamificacion-carrera-pok",
        "pt": "credenciais-digitais-microcredenciais-gamificacao-carreira-pok"
    },
    {
        "en": "microcredentials-job-market-new-workers-pok",
        "es": "microcredenciales-mercado-laboral-nuevos-trabajadores-pok",
        "pt": "microcredenciais-mercado-de-trabalho-novos-profissionais-pok"
    },
    {
        "en": "pok-us-launch-digital-credentials-software-nft-open-badge",
        "es": "pok-lanzamiento-eeuu-software-credenciales-digitales-nft-open-badge",
        "pt": "pok-lancamento-eua-software-credenciais-digitais-nft-open-badge"
    },
    {
        "en": "pok-lacnet-alliance-nft-digital-credentials-blockchain",
        "es": "pok-lacnet-alliance-nft-digital-credentials-blockchain",
        "pt": "pok-lacnet-alianca-nft-credenciais-digitais-blockchain"
    },
    {
        "en": "pok-global-nft-digital-credentials-platform",
        "es": "pok-plataforma-global-credenciales-digitales-nft",
        "pt": "pok-plataforma-global-credenciais-digitais-nft"
    },
    {
        "en": "certify-product-blockchain-digital-credentials-quality-pok",
        "es": "certificar-producto-blockchain-credenciales-digitales-calidad-pok",
        "pt": "certifique-produto-credenciais-digitais-blockchain-qualidade-pok"
    },
    {
        "en": "simplify-digital-certificates-with-pok",
        "es": "simplifica-certificados-digitales-con-pok",
        "pt": "simplifique-certificados-digitais-com-pok"
    },
    {
        "en": "benefits-of-digital-certification-trust-security-growth",
        "es": "beneficios-certificacion-digital-confianza-seguridad-crecimiento-pok",
        "pt": "beneficios-certificacao-digital-confianca-seguranca-crescimento"
    },
    {
        "en": "nft-digital-credentials-verification-ownership-trust",
        "es": "credenciales-digitales-nft-verificacion-propiedad-confianza",
        "pt": "credenciais-digitais-nft-verificacao-propriedade-confianca"
    },
    {
        "en": "pok-digital-credentials-definition-benefits-blockchain-nft",
        "es": "pok-credenciales-digitales-que-son-beneficios-blockchain-nft",
        "pt": "pok-credenciais-digitais-o-que-sao-beneficios-blockchain-nft"
    },
    {
        "en": "what-are-digital-credentials-nfts-blockchain-future-pok",
        "es": "que-son-credenciales-digitales-nft-blockchain-futuro-pok",
        "pt": "credenciais-digitais-nfts-blockchain-futuro-pok"
    },
    {
        "en": "digital-credentials-types-applications-benefits",
        "es": "credenciales-digitales-tipos-aplicaciones-beneficios",
        "pt": "credenciais-digitais-tipos-aplicacoes-beneficios"
    },
    {
        "en": "pok-free-digital-credentials",
        "es": "pok-credenciales-digitales-gratis",
        "pt": "pok-credenciais-digitais-gratis"
    },
    {
        "en": "pok-iso-27001-certification-digital-credentials-security",
        "es": "pok-certificacion-iso-27001-credenciales-digitales-seguridad",
        "pt": "pok-certificacao-iso-27001-credenciais-digitais-seguranca"
    },
    {
        "en": "pok-future-digital-credentials-trust-impact",
        "es": "pok-futuro-credenciales-digitales-confianza-impacto",
        "pt": "pok-futuro-credenciais-digitais-confianca-impacto"
    },
    {
        "en": "universidad-insurgentes-microcredentials-ecosystem-success-case-pok",
        "es": "universidad-insurgentes-pok-ecosistema-microcredenciales-caso-exito",
        "pt": "universidade-insurgentes-pok-ecossistema-microcredenciais-caso-sucesso"
    },
    {
        "en": "how-to-implement-microcredentials-university-step-by-step",
        "es": "como-implementar-microcredenciales-universidad-paso-a-paso",
        "pt": "como-implementar-microcredenciais-universidade-passo-a-passo"
    },
    {
        "en": "pok-digital-credentials-education-careers-trust",
        "es": "pok-credenciales-digitales-educacion-carreras-confianza",
        "pt": "pok-credenciais-digitais-educacao-carreiras-confianca"
    },
    {
        "en": "digital-credential-wallet-complete-guide-2025",
        "es": "wallet-credenciales-digitales-guia-completa-2025",
        "pt": "carteira-credenciais-digitais-guia-completo-2025"
    },
    {
        "en": "uplanner-future-digital-education-latin-america",
        "es": "uplanner-futuro-educacion-digital-america-latina",
        "pt": "uplanner-futuro-educacao-digital-america-latina"
    },
    {
        "en": "pok-uassessment-alliance-digital-credentials",
        "es": "pok-uassessment-alianza-credenciales-digitales",
        "pt": "pok-uassessment-alianca-credenciais-digitais"
    },
    {
        "en": "digital-credentials-competitive-advantage-universities",
        "es": "credenciales-digitales-ventaja-competitiva-universidades",
        "pt": "credenciais-digitais-vantagem-competitiva-universidades"
    },
    {
        "en": "pok-colombia-edtech-alliance-digital-credentials-nft",
        "es": "pok-colombia-edtech-alianza-credenciales-digitales-nft",
        "pt": "pok-colombia-edtech-alianca-credenciais-digitais-nft"
    },
    {
        "en": "pok-vs-digital-credential-platforms-nft-blockchain-guide",
        "es": "pok-vs-plataformas-credenciales-digitales-nft-blockchain",
        "pt": "pok-vs-plataformas-credenciais-digitais-guia-nft-blockchain"
    },
    {
        "en": "credly-accredible-accreditta-vs-pok-digital-credentials-pricing-2026",
        "es": "credly-accredible-accreditta-vs-pok-credenciales-digitales-2026",
        "pt": "pok-vs-credly-accredible-accreditta-credenciais-digitais-2026"
    },
    {
        "en": "future-microcredentials-education-employability-statistics-2025",
        "es": "futuro-microcredenciales-educacion-empleabilidad-estadisticas-2025",
        "pt": "futuro-microcredenciais-educacao-empregabilidade-estatisticas-2025"
    },
    {
        "en": "university-degree-digital-credentials",
        "es": "titulo-universitario-credenciales-digitales",
        "pt": "diploma-universitario-credenciais-digitais"
    },
    {
        "en": "case-study-uabc-digital-nft-credentials",
        "es": "caso-exito-uabc-credenciales-digitales-nft-mexico",
        "pt": "caso-sucesso-uabc-credenciais-digitais-nft"
    },
    {
        "en": "university-to-workplace-digital-credentials-employability-pok",
        "es": "universidad-empleo-credenciales-digitales-empleabilidad-pok",
        "pt": "universidade-mercado-trabalho-credenciais-digitais-empregabilidade-pok"
    },
    {
        "en": "rank-top-universities-digital-credentials-pok",
        "es": "posiciona-universidades-top-credenciales-digitales-pok",
        "pt": "melhores-universidades-ranking-credenciais-microcredenciais-digitais-pok"
    },
    {
        "en": "stand-out-job-market-blockchain-digital-credentials-pok",
        "es": "mercado-laboral-credenciales-digitales-blockchain-pok",
        "pt": "destacar-mercado-trabalho-credenciais-digitais-blockchain-pok"
    },
    {
        "en": "student-centered-learning-digital-credentials-pok",
        "es": "aprendizaje-estudiante-credenciales-digitales-pok",
        "pt": "aprendizagem-centrada-no-estudante-credenciais-digitais-pok"
    },
    {
        "en": "future-of-universities-digital-transformation-pok",
        "es": "futuro-universidades-transformacion-digital-pok",
        "pt": "futuro-universidades-transformacao-digital-pok"
    },
    {
        "en": "digital-credentials-talent-potential-pok",
        "es": "credenciales-digitales-potencial-talento-pok",
        "pt": "credenciais-digitais-talento-potencial-pok"
    }
]
